// Constants
import { OrganizationRole } from 'Shared/constants/types';

// API
import * as SubsciptionsAPI from '../api/Subscriptions.api';

// Components
import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { tr } from 'Shared/utils/hooks/use-translation';

export const fetchPlanInfo = params => () => {
  return SubsciptionsAPI.fetchPlanInfo(params).then(response => {
    // we do not store plan info in redux, just return the data
    return response.data;
  });
};

export const fetchActiveSubscription = () => () => {
  return SubsciptionsAPI.getActiveSubscription().then(response => response.data);
};

export const cancelSubscription = () => dispatch => {
  return SubsciptionsAPI.cancelSubscription().then(response => {
    dispatch({
      type: 'UPDATE_ORGANIZATION_REQUEST',
      payload: { organization: response.data.organization },
    });
  });
};

export const chooseFreePlan = () => dispatch => {
  return SubsciptionsAPI.chooseFreePlan().then(response => {
    WpToastManager.success(tr('perform.subscriptions.actions.basic_plan_activated'));
    dispatch({
      type: 'UPDATE_ORGANIZATION_REQUEST',
      payload: { organization: response.data.organization },
    });
  });
};

export const updateSubscriptionDetails = data => dispatch => {
  return SubsciptionsAPI.updateSubscriptionDetails(data).then(response => {
    dispatch({
      type: 'UPDATE_SUBSCRIPTION_DETAILS_SUCCESS',
      payload: { organization: response.data.organization },
    });
  });
};

export const updateCreditCard = data => dispatch => {
  return SubsciptionsAPI.updateCreditCard(data)
    .then(response => {
      dispatch({
        type: 'subscriptions/UPDATE_CREDIT_CARD',
        payload: response.data,
      });

      WpToastManager.success(tr('perform.subscriptions.actions.card_updated'));
      return response.data;
    })
    .catch(err => {
      return err;
    });
};

export const createSubscription = data => dispatch => {
  return SubsciptionsAPI.createSubscription(data).then(response => {
    dispatch({
      type: 'UPDATE_ORGANIZATION_REQUEST',
      payload: {
        organization: {
          billingState: response.data.billing_state,
          features: response.data.features,
          blockAllUserAccess: false,
        },
      },
    });
    // Ensure redux updates to reflect that the user is an org admin in case they weren't before payment
    dispatch({
      type: 'UPDATE_USER_DATA_RESPONSE',
      payload: { organizationRole: OrganizationRole.admin, isOrganizationAdmin: true },
    });
    WpToastManager.success(tr('perform.subscriptions.actions.payment_successful'));
    return response;
  });
};
